import React from 'react';
import { CheckCircle2, Target, Heart, Shield } from 'lucide-react';

export const AboutSection = () => {
  const values = [
    {
      icon: Target,
      title: 'Präzision',
      description: 'Exakte Lieferungen nach Ihren Vorgaben'
    },
    {
      icon: Heart,
      title: 'Partnerschaft',
      description: 'Langfristige Kundenbeziehungen'
    },
    {
      icon: Shield,
      title: 'Zuverlässigkeit',
      description: 'Termingerechte Lieferung garantiert'
    }
  ];

  return (
    <section id="ueber-uns" className="py-20 lg:py-32 bg-gradient-to-br from-gray-50 to-white">
      <div className="container mx-auto px-4">
        <div className="grid lg:grid-cols-2 gap-16 items-center">
          {/* Left Content */}
          <div className="space-y-8">
            <div>
              <span className="inline-block px-4 py-2 rounded-full bg-[#8B1538]/10 text-[#8B1538] text-sm font-semibold mb-4">
                Über KALEM
              </span>
              <h2 className="text-4xl lg:text-5xl font-bold text-gray-900 mb-6">
                Ihr Partner für professionelle Bauprojekte
              </h2>
            </div>

            <div className="space-y-6 text-lg text-gray-600 leading-relaxed">
              <p>
                Als etablierter Baustoffhändler beliefern wir Bauunternehmen, Handwerksbetriebe und Bauträger in ganz Deutschland mit hochwertigen Baumaterialien.
              </p>
              <p>
                Unsere Stärke liegt in der Kombination aus umfassendem Sortiment, technischer Beratung und zuverlässiger Logistik. Wir verstehen die Anforderungen des modernen Baugewerbes und liefern genau das, was Sie für den Projekterfolg benötigen.
              </p>
            </div>

            {/* Key Features */}
            <div className="space-y-4">
              {[
                'Umfassendes Sortiment für alle Gewerke',
                'Deutschlandweite Lieferung',
                'Technische Fachberatung',
                'Flexible Zahlungskonditionen für Geschäftskunden',
                'Termintreue Logistik'
              ].map((feature, index) => (
                <div key={index} className="flex items-start space-x-3">
                  <CheckCircle2 className="w-6 h-6 text-[#8B1538] flex-shrink-0 mt-1" />
                  <span className="text-gray-700 font-medium">{feature}</span>
                </div>
              ))}
            </div>
          </div>

          {/* Right Content - Values */}
          <div className="space-y-6">
            <div className="bg-white rounded-2xl shadow-xl p-8 lg:p-12 border border-gray-200">
              <h3 className="text-2xl font-bold text-gray-900 mb-8">
                Unsere Werte
              </h3>
              
              <div className="space-y-8">
                {values.map((value, index) => {
                  const Icon = value.icon;
                  return (
                    <div key={index} className="flex items-start space-x-4">
                      <div className="flex-shrink-0 w-12 h-12 rounded-lg bg-[#8B1538]/10 flex items-center justify-center">
                        <Icon className="w-6 h-6 text-[#8B1538]" />
                      </div>
                      <div>
                        <h4 className="text-xl font-bold text-gray-900 mb-2">
                          {value.title}
                        </h4>
                        <p className="text-gray-600">
                          {value.description}
                        </p>
                      </div>
                    </div>
                  );
                })}
              </div>
            </div>

            {/* Stats */}
            <div className="grid grid-cols-2 gap-6">
              <div className="bg-[#8B1538] rounded-xl p-6 text-white">
                <div className="text-3xl font-bold mb-2">100+</div>
                <div className="text-white/90">Zufriedene Kunden</div>
              </div>
              <div className="bg-gray-800 rounded-xl p-6 text-white">
                <div className="text-3xl font-bold mb-2">24h</div>
                <div className="text-white/90">Lieferbereitschaft</div>
              </div>
            </div>
          </div>
        </div>
      </div>
    </section>
  );
};